import script from "./PodcastFollowButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./PodcastFollowButton.vue?vue&type=script&setup=true&lang=ts"

import "./PodcastFollowButton.vue?vue&type=style&index=0&id=49c2c753&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49c2c753"]])

export default __exports__